import { render } from "./headerFacture.vue?vue&type=template&id=60c16ba1"
import script from "./headerFacture.vue?vue&type=script&lang=ts"
export * from "./headerFacture.vue?vue&type=script&lang=ts"
script.render = render

export default script